import { render, staticRenderFns } from "./ProofOfWorkType.vue?vue&type=template&id=1d7eaba8&scoped=true&"
import script from "./ProofOfWorkType.vue?vue&type=script&lang=js&"
export * from "./ProofOfWorkType.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfWorkType.vue?vue&type=style&index=0&id=1d7eaba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7eaba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VBtnToggle,VRow,VSpacer,VToolbar})
